// extracted by mini-css-extract-plugin
export default {"notesContent":"NotesViewModal_notesContent__Xkwok"};